import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PaymentService } from '../../services/payment.service';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import {
  PageChangeEvent,
  SelectableSettings,
  RowArgs
} from '@progress/kendo-angular-grid';
import { State } from '../../../store/reducers';

@Component({
  selector: 'app-list-grid',
  templateUrl: 'list-grid.component.html'
})
export class ListGridComponent implements OnInit {
  paidForAccommodation$: Observable<boolean>;
  paidForConference$: Observable<boolean>;
  @Input() bookings: any[] = [];
  @Output() onEditBooking = new EventEmitter<any>();
  @Output() onDeleteBooking = new EventEmitter<any>();
  @Output() onViewBooking = new EventEmitter<any>();
  @Output() onViewConferenceConfirmation = new EventEmitter<any>();
  @Output() onViewAccommodationConfirmation = new EventEmitter<any>();

  public pageSize = 10;
  public skip = 0;

  constructor(
    public paymentService: PaymentService,
    public store: Store<State>
  ) {
    paymentService.checkAccommodationPayment();
    paymentService.checkConferencePayment();
  }

  ngOnInit() {
    this.paidForAccommodation$ = this.store.select(
      state => state.payment.paidForAccommodation
    );
    this.paidForConference$ = this.store.select(
      state => state.payment.paidForConference
    );
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
  }

  editCurrentBooking(bookingId) {
    this.onEditBooking.emit(bookingId);
  }

  deleteBooking(bookingId) {
    this.onDeleteBooking.emit(bookingId);
  }

  viewCurrentBooking(booking) {
    this.onViewBooking.emit(booking);
  }

  viewConf(bookingId) {
    this.onViewConferenceConfirmation.emit(bookingId);
  }

  viewAccom(bookingId) {
    this.onViewAccommodationConfirmation.emit(bookingId);
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/components/list-grid/list-grid.component.ts